import { AdPlacement } from "@/components/ads/AdPlacement";
import { m } from "@/paraglide/messages";
import { ColorConverter } from "../components/ColorConverter";
import { CvBreadcrumb } from "../components/CvBreadcrumb";
import { CvExplainer } from "../components/CvExplainer";

export function ColorConverterPage() {
  return (
    <div className="relative">
      <div className="pointer-events-none absolute inset-0 gradient-mesh" />
      <div className="relative mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <CvBreadcrumb />

        <header className="mb-8 mt-6">
          <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
            {m.cv_h1()}
          </h1>
          <p className="mt-3 leading-relaxed text-muted-foreground">
            {m.cv_intro()}
          </p>
        </header>

        <ColorConverter />

        <CvExplainer
          howTo={m.cv_howto()}
          faqs={[
            { q: m.cv_faq1_q(), a: m.cv_faq1_a() },
            { q: m.cv_faq2_q(), a: m.cv_faq2_a() },
            { q: m.cv_faq3_q(), a: m.cv_faq3_a() },
            { q: m.cv_faq4_q(), a: m.cv_faq4_a() },
          ]}
        />

        <AdPlacement className="mt-10" />
      </div>
    </div>
  );
}
